import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Scissors, BookOpen, Clapperboard } from 'lucide-react';
export function About() {
  return <section id="sobre-mi" className="py-32 relative overflow-hidden" data-id="element-11" data-mp="2ptkyjah5us77">
      {/* Background glow */}
      <div className="absolute top-1/2 right-0 w-1/2 h-1/2 bg-neon-green/10 rounded-full mix-blend-screen filter blur-[120px] -translate-y-1/2 transform-gpu will-change-transform" data-id="element-12" data-mp="2tv6itgw0y8rf" />

      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-13" data-mp="33qqb7tbdqpbf">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-14" data-mp="38pt5ciptnb4m">
          {/* Image Side */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-15" data-mp="3dgjco1ht5o1y">
            <div className="relative z-10 rounded-3xl p-[3px] bg-gradient-to-r from-neon-violet via-fuchsia-400 to-neon-green max-w-md mx-auto lg:mx-0" data-id="element-16" data-mp="3rg15qt24znh4">
              <div className="relative rounded-[21px] overflow-hidden aspect-square" data-id="element-17" data-mp="2lp4ictn98wki">
                <img src="https://cdn.magicpatterns.com/uploads/ub9Px25FqqtoEmg4twcrir/heylloyd-image-1782483449522.webp" alt="Equipo de Barbería Ninja 2.0" className="w-full h-full object-cover transition-all duration-700" loading="lazy" decoding="async" width="800" height="800" data-id="element-18" data-mp="2gqt66c9hm9z4" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent" data-id="element-19" data-mp="30ihii3jkaf6w" />
              </div>
            </div>
          </motion.div>

          {/* Content Side */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-20" data-mp="3o5plufxfje6a">
            <h2 className="font-display text-6xl md:text-8xl mb-6" data-id="element-21" data-mp="66lt5s4tic6q">
              Quiénes <br data-id="element-22" data-mp="b3ltdmezkkpx" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-violet via-fuchsia-400 to-neon-green" data-id="element-23" data-mp="b45cv7kabh62">
                Somos
              </span>
            </h2>

            <div className="space-y-6 text-gray-400 text-lg leading-relaxed" data-id="element-24" data-mp="1dkf1mcfqgo7">
              <p data-id="element-25" data-mp="3jjowrfz2fn8g">
                Somos un equipo de barberos apasionados con base en El Pinar,
                Canelones, unidos por una misma visión: fusionar el arte urbano
                con la precisión técnica. No solo cortamos cabello; esculpimos
                identidades.
              </p>
              <p data-id="element-26" data-mp="3emovdid5v8no">
                Cada uno de nosotros aporta su propio estilo —desde la
                colorimetría extrema y los cortes de autor hasta los fades y la
                barba clásica—, creando un espacio donde cada cliente encuentra
                exactamente lo que busca.
              </p>
              <p data-id="element-27" data-mp="2xd4c7lyai6jt">
                En{' '}
                <strong className="text-white font-semibold" data-id="element-28" data-mp="2tapx9cxqrqxt">
                  Barbería Ninja 2.0
                </strong>{' '}
                trabajamos para elevar el estándar de la barbería en Uruguay,
                tratando cada servicio como una verdadera obra maestra.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-6 mt-12 pt-12 border-t border-white/10" data-id="element-29" data-mp="3h025oal8vuz2">
              <div data-id="element-30" data-mp="3c1hdmyg5chlp">
                <p className="font-display text-5xl text-white mb-1" data-id="element-31" data-mp="3c20l1l867nlh">+5</p>
                <p className="text-sm text-gray-500 uppercase tracking-wider font-semibold" data-id="element-32" data-mp="3q10c0zj5oekt">
                  Años de Experiencia
                </p>
              </div>
              <div data-id="element-33" data-mp="3l2p1snoy8222">
                <p className="font-display text-5xl text-white mb-1" data-id="element-34" data-mp="1vmzau804vfhk">+200</p>
                <p className="text-sm text-gray-500 uppercase tracking-wider font-semibold" data-id="element-35" data-mp="1vn7m5vglycqn">
                  Alumnos Formados
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}